<template>
    <div class="configurator">

        <!-- Title -->
        <div v-if="isLoggedIn" class="configurator__title mt-4">
            <h1 class="d-inline">{{ $t('configurator.configurator') }}</h1>
            <router-link :to="{ name: 'Overview' }" class="medium-button blue-gradient quotation-button">{{ $t('quotation.quotationOverview') }} ({{$store.state.quoteCart.length}})</router-link>
        </div>



        <!-- BOX CONTAINER -->
        <div v-if="configuredApron != null" class="configurator__box bg-white rounded-10 shadow mb-3 ">

            <!-- Box title-->
            <div class=" border-bottom configurator__box-title mt-4">
                <div v-if="!objFavourite.name">
                    <h2 class="" v-if="configuredApron.model.setName != ''">{{ $t('quotation.configureYourModel', [configuredApron.model.setName]) }}</h2>
                    <h2 class="" v-else>{{ $t('quotation.configureYourModel', [configuredApron.model.name]) }}</h2>
                </div>
                <div v-else>
                    <h2>{{objFavourite.name}}</h2>
                </div>
            </div>

            <!-- Configurator -->
            <div class="configurator__content" id="configurator" ref="configurator">


                <div class="configurator__properties-wrapper">
                    <!-- Properties of apron or vest -->
                    <div v-show="configuredApron.includeInQuote == true" class="configurator__properties border rounded ">

                        <div class=" " id="propertiesApron">
                            <apron-config v-model="configuredApron" :favouriteid="objFavourite.favouriteApronID" query-param-to-update="sku">
                                <div v-if="configuredSkirt != null && configuredSkirt.includeInQuote == true" class="skirt-identical"> </div>
                            </apron-config>

                            <!--<button v-if="configuredApron.model.setWith > 0 && configuredSkirt != null" v-on:click="SyncToSkirt()" class="medium-button blue-gradient"><b-icon-arrow-repeat /> Sync</button>-->
                        </div>
                    </div>

                    <!--Skirt Properties-->
                    <div v-show="configuredSkirt != null && configuredSkirt.includeInQuote == true && (ItemsIdentical == false || blnSyncEnabled == false)" class="configurator__properties border rounded ">
                        <div class=" " id="propertiesSkirt">
                            <apron-config v-model="configuredSkirt" :favouriteid="objFavourite.favouriteApronID" query-param-to-update="sku2"></apron-config>
                        </div>
                    </div>
                </div>

                <!-- Result -->
                <div class="configurator__preview-box">

                    <!-- selection Vest and/or skirt-->
                    <div v-if="configuredSkirt != null" class="configurator__vest-skirt-selection">
                        <input type="checkbox" v-model="blnSyncEnabled" id="chkSync" class="mr-2" /> <label for="chkSync" class="mr-3">{{ $t('quotation.skirtIdentical') }}</label>

                        <div class=" pr-3 pl-3 p-2 bg-light  configurator__vest-skirt-selector">
                            <div class="mr-2">{{$t('quotation.include')}}:</div>
                            <div class="mr-2"><input type="checkbox" v-model="configuredApron.includeInQuote" /> {{ $t('quotation.vest') }}</div>
                            <div><input type="checkbox" v-model="configuredSkirt.includeInQuote" /> {{ $t('quotation.skirt') }}</div>
                        </div>

                    </div>

                    <!-- Prieview configured apron-->
                    <div class="configurator__preview-wrapper">
                        <apron-preview :configured-apron="configuredApron" :configured-skirt="configuredSkirt" class="configurator__preview"></apron-preview>
                    </div>
                </div>

                <!-- Controls -->
            </div>
            <div class="configurator__controls">

                <!-- Back button & share button -->
                <div v-if="blnEditingQuote == false" class="configurator__controls-left">
                    <navigation-button v-if="$route.name == 'Quotation'" mode="back" :allow-press="true" @button-clicked="goBack()" class="d-inline-block mr-3"></navigation-button>
                    <button v-on:click="copyPageUrl()" class="medium-button blue-gradient d-inline-block mr-3 icon-button"><b-icon-share-fill class="mr-1" /> <span class="d-md-inline-block d-sm-none d-none">{{ $t('general.share') }}</span></button>
                    <!--<transition name="fade">
                        <span v-if="isCopied == true" class="message small"><b-icon-files /> {{ $t('quotation.urlCopied') }}</span>
                    </transition>-->
                    <!--<router-link :to="{ name: 'ProductSelector' }" class="medium-button blue-gradient">Back</router-link>-->
                </div>

                <!-- Quantity, Add/Favorite button -->

                <div v-if="isLoggedIn" class="configurator__controls-right">
                    <a v-if="blnFavIsChanged == true && AllowAddToQuote && blnIsFav" v-on:click="updateFavorite()" class="configurator__save-changes small-button color-magenta small">{{ $t('general.save') }}</a>
                    <div class="mr-3">
                        <button type="button" v-on:click="SaveToFavorites()" :class="[{'favorite-button': AllowAddToQuote },{'favorite-button-active' : objFavourite.name},{ 'favorite-button-disabled': !AllowAddToQuote}]  ">
                            <svg version="1.1" id="Laag_1" viewBox="0 0 512 512">
                                <path class="icon" d="M451.6,269.2L276.5,450c-11.3,11.7-29.7,11.7-41,0L60.3,269.2C9.4,216.6,12.4,129.5,69.3,81c49.6-42.3,123.5-34.7,168.9,12.3l17.8,18.4l17.8-18.4c45.5-47,119.3-54.6,168.9-12.3C499.6,129.5,502.6,216.6,451.6,269.2z" />
                            </svg>
                        </button>
                    </div>
                    <label class="mr-2">{{ $t('quotation.quantity') }}</label>
                    <input type="number" v-model.number="intQuantity" :min="1" class="mr-4" />
                    <div v-if="blnEditingQuote == false" class="d-inline-block">
                        <button type="button" v-on:click="AddToQuote()" :class="(AllowAddToQuote ? 'medium-button blue-gradient' : 'medium-button disabled') ">{{ $t('quotation.addToQuote') }}</button>
                    </div>
                    <div v-else>
                        <button type="button" v-if="AllowAddToQuote" v-on:click="SaveChanges()" class="icon-button medium-button blue-gradient">{{ $t('general.saveChanges') }}</button>
                        <button type="button" v-else class="icon-button medium-button disabled-button">{{ $t('general.saveChanges') }}</button>
                    </div>


                </div>

            </div>
            <div v-if="isLoggedIn" class="configurator__form-incomplete text-right">
                <span class="small">{{strFormIncomplete}}</span>
            </div>


        </div>
    </div>
    <!--</div>

        </div>
    </div>-->
    <!--</div>-->
    <!--</div>-->
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex';
    //import { dynamicSort, updateHeight } from '@/scripts/General.js'
    import { dynamicSort } from '@/scripts/General.js';
    import * as general from '@/scripts/General.js';
    import ApronConfig from '@/private/components/Configurator/ApronConfig.vue';
    import ApronPreview from '@/private/components/Configurator/ApronPreview.vue';
    import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
    import SaveFavorite from "@/private/components/ModalContent/SaveFavorite.vue";
    import Bus from '@/Bus.js';



    var _ = require('lodash');

    export default {
        name: 'Quotation',

        props: {

        },
        components: {
            ApronConfig,
            ApronPreview,
            NavigationButton,

        },
        data: function () {



            return {
                storeLoading: true,
                lstModels: [], //List of all available models,
                blnEditingQuote: false,
                emptyConfig: null,
                configuredApron: null,
                configuredSkirt: null,
                lstValidationErrors: [],
                blnShowFabricPanel: true,
                blnShowRibbonPanel: false,
                //blnShowCart: false,
                isCopied: false,
                blnSyncEnabled: true,
                objFavourite: { favouriteApronID: 0, name: '', sku: null, skuSkirt: null },
                updateSuccesfull: false,
                err: false
            }

        },
        beforeMount: function () {

        },
        mounted: function () {
            //updateHeight();

            this.$store.dispatch('GET_quoteCart')

            if (this.$route.params.favouriteid > 0) {
                //Get favourite object
                var params = { FavID: this.$route.params.favouriteid }


                axios.get('/Dashboard/GetFavouriteById', { params })
                    .then((response) => {

                        if (response.data == "") {
                            this.objFavourite = { favouriteApronID: 0, name: '', sku: null, skuSkirt: null }
                        } else {
                            this.objFavourite = response.data
                        }


                    })
                    .catch(function (error) {
                        alert(error);
                    });

            }

            Bus.$on('favourite-saved', (newFav) => this.objFavourite = newFav)



        },
        methods: {
            updateFavorite: function () {
                this.objFavourite.sku = this.$route.params.sku;
                this.objFavourite.skuSkirt = this.$route.params.sku2;

                axios.post('/Dashboard/AddOrUpdateFavourite', this.objFavourite, {
                    headers: { 'content-type': 'application/json' }
                }).then((response) => {

                    console.log(response);

                    if (response.status == '200' && response.data !== "Error") {
                        this.updateSuccesfull = true;
                        this.objFavourite = response.data

                    } else {
                        this.err = true;
                    }
                })
                    .catch(function (error) {
                        alert(error);
                    }
                    );

                //this.blnIsFav = true;
            },

            async copyPageUrl() {

                let returnValue = location.href

                returnValue = returnValue.replace('/' + this.$route.params.favouriteid + '/', '/')
                returnValue = returnValue.replace('/LAA/Configurator', '/Configurator');

                const shareData = {
                    title: this.$t('quotation.shareTitle'),
                    text: this.$t('quotation.shareText'),
                    url: returnValue
                }

                try {
                    await navigator.share(shareData);
                    return this.isCopied = true;
                } catch (err) {
                    console.error('Failed to copy: ', err);
                }

                //try {
                //    let returnValue = location.href

                //    returnValue = returnValue.replace('/' + this.$route.params.favouriteid + '/', '/')

                //    returnValue = returnValue.replace('/LAA/Configurator', '/Configurator');

                //    await navigator.clipboard.writeText(returnValue);
                //    return this.isCopied = true;

                //} catch (err) {
                //    console.error('Failed to copy: ', err);
                //}
            },

            GetStoreModel: function () {

                this.storeLoading = true;

                axios.get('/Store/GetStoreModel')
                    .then((response) => {
                        this.lstModels = response.data.lstModels;

                        //Make a clone that can be detached
                        this.emptyConfig = response.data.configuredApron;

                        if (this.$route.query.editApronID != null) {

                            this.blnEditingQuote = true

                            //Get the apron from the local storage and edit it
                            this.configuredApron = this.$store.state.quoteCart.find(x => x.quoteApronID == this.$route.query.editApronID)

                            //Communicate SKUs to store
                            this.$store.commit('SET_sku1', this.configuredApron.sku)

                            if (this.configuredApron.quoteSetWith > 0) {
                                //Find the other item as well
                                this.configuredSkirt = this.$store.state.quoteCart.find(x => x.quoteApronID == this.configuredApron.quoteSetWith)

                                //Communicate SKUs to store
                                this.$store.commit('SET_sku2', this.configuredSkirt.sku)
                            }

                            this.intQuantity = this.configuredApron.quantity

                        } else {
                            this.blnEditingQuote = false

                            this.configuredApron = this.skuToConfig(this.$route.params.sku)

                            if (typeof this.$route.params.sku2 == 'undefined' && this.configuredApron.model.setWith > 0) {
                                //Also set up skirt
                                this.configuredSkirt = this.skuToConfig(String(this.configuredApron.model.setWith))
                            } else {
                                //Skirt is already in URL
                                this.configuredSkirt = this.skuToConfig(this.$route.params.sku2)


                            }

                            //Communicate SKUs to store
                            this.$store.commit('SET_sku1', this.$route.params.sku)
                            this.$store.commit('SET_sku2', this.$route.params.sku2)

                            this.intQuantity = 1
                        }

                        this.blnSyncEnabled = this.ItemsIdentical


                        this.storeLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            SaveChanges: function () {
                //Push apron
                this.$store.commit('ADDorUPDATE_quoteCart', this.configuredApron)

                //Push skirt
                if (this.configuredSkirt != null) {
                    this.$store.commit('ADDorUPDATE_quoteCart', this.configuredSkirt)
                }

                this.$router.push({ name: 'Overview' }).catch(() => { });
            },
            AddToQuote: function () {
                //Adds the current configuration to the quote cart
                //Refresh first
                var localQuoteCart = localStorage.getItem('QuoteCart');

                if (localQuoteCart == null) {
                    localQuoteCart = []

                } else {
                    localQuoteCart = JSON.parse(localQuoteCart)
                }

                var quoteApronID = 0

                //Apron
                if (localQuoteCart.filter(x => x.quoteApronID == this.configuredApron.quoteApronID).length == 0) {
                    //Add
                    if (localQuoteCart.length > 0) {
                        //Find highest number so far
                        localQuoteCart.sort(dynamicSort("quoteApronID", false))

                        //Give this new apron a +1
                        this.configuredApron.quoteApronID = localQuoteCart[localQuoteCart.length - 1].quoteApronID + 1
                    } else {
                        //First apron to add
                        this.configuredApron.quoteApronID = 1
                    }
                }

                quoteApronID = this.configuredApron.quoteApronID + 1

                //In case of skirt/vest combination, also add skirt
                if (this.configuredSkirt != null) {
                    if (localQuoteCart.filter(x => x.quoteApronID == this.configuredSkirt.quoteApronID).length == 0) {
                        //Add
                        if (localQuoteCart.length > 0) {
                            //Give this new apron a +1
                            this.configuredSkirt.quoteApronID = quoteApronID
                        } else {
                            //First apron to add
                            this.configuredSkirt.quoteApronID = quoteApronID
                        }
                    }
                }

                //Link if necessary
                if (this.configuredSkirt != null && this.configuredApron.includeInQuote && this.configuredSkirt.includeInQuote) {
                    this.configuredApron.quoteSetWith = this.configuredSkirt.quoteApronID
                    this.configuredSkirt.quoteSetWith = this.configuredApron.quoteApronID
                }



                //Push apron
                if (this.configuredApron.includeInQuote) {
                    this.$store.commit('ADDorUPDATE_quoteCart', this.configuredApron)
                }


                //Push skirt
                if (this.configuredSkirt != null) {
                    if (this.configuredSkirt.includeInQuote) {
                        this.$store.commit('ADDorUPDATE_quoteCart', this.configuredSkirt)
                    }
                }

                this.$router.push({ name: 'Overview' }).catch(() => { });

            },
            skuToConfig: function (sku) {
                if (typeof sku == 'undefined') {
                    return null
                } else if (sku.length < 2) {
                    return null
                } else {

                    var returnValue = {}

                    returnValue = JSON.parse(JSON.stringify(this.emptyConfig));

                    //Set up config from slug
                    const newApronModelID = parseInt(sku.substring(0, 2))

                    //Set category based on model
                    var futureModel = this.lstModels.filter(x => x.apronModelID == newApronModelID)[0]

                    if (typeof futureModel == 'undefined') {
                        //try fetching set items
                        futureModel = this.lstModels.filter(x => x.setModel != null).filter(x => x.setModel.apronModelID == newApronModelID)[0].setModel
                    }

                    //if (this.blnIsFav) {
                    this.$store.commit('SET_chosenCategory', futureModel.category);
                    //}


                    //First two characters: model
                    returnValue.apronModelID = newApronModelID;
                    returnValue.model = futureModel

                    if (sku.length == 2) {
                        //Model only
                        return returnValue;
                    }

                    //PbEqFront
                    returnValue.pbEqFront = sku.substring(2, 3)


                    //PbEqBack
                    returnValue.pbEqBack = sku.substring(3, 4)

                    //Size
                    var test2 = sku.substring(4, 5)

                    var currentIndex = 4
                    if (test2 == '-') {
                        //Undefined size
                        returnValue.size = -1
                        currentIndex = 6
                    } else {
                        returnValue.size = parseInt(sku.substring(currentIndex, currentIndex + 1))

                        currentIndex += 1
                    }

                    //Material
                    var internalMaterial = sku.substring(currentIndex, currentIndex + 2)

                    currentIndex += 2

                    if (internalMaterial == "OF") {
                        returnValue.internalMaterial = 1
                    } else if (internalMaterial == "OA") {
                        returnValue.internalMaterial = 2
                    } else if (internalMaterial == "NL") {
                        returnValue.internalMaterial = 3
                    } else if (internalMaterial == "LL") {
                        returnValue.internalMaterial = 4
                    }

                    //Length
                    var length = parseInt(sku.substring(currentIndex, currentIndex + 3))
                    var adjustment = length - futureModel.defaultLength

                    if (adjustment != 0) {
                        var newAdjustment = {
                            adjustmentType: 1,
                            parameter1: adjustment
                        }
                        returnValue.sizeAdjustments.push(newAdjustment);
                    }

                    //extra overlap

                    //Cablon part of the SKU
                    currentIndex = sku.indexOf(':') + 1

                    //Fabric color
                    var fabricColor = sku.substring(currentIndex, currentIndex + 2)
                    if (currentIndex != null) {
                        returnValue.fabricColorID = parseInt(fabricColor)
                        if (returnValue.fabricColorID != 0) {
                            returnValue.fabricColor = returnValue.model.fabricsForApron.find(x => x.fabricColorID == returnValue.fabricColorID).fabricColor
                        } else {
                            returnValue.fabricColor = {}
                        }

                    }

                    currentIndex += 2

                    //Ribbon color
                    var ribbonColor = sku.substring(currentIndex, currentIndex + 2)
                    if (currentIndex != null) {
                        returnValue.ribbonColorID = parseInt(ribbonColor)
                        if (returnValue.ribbonColorID != 0) {
                            returnValue.ribbonColor = returnValue.model.ribbonsForApron.find(x => x.ribbonColorID == returnValue.ribbonColorID).ribbonColor
                        } else {
                            returnValue.ribbonColor = {}
                        }

                    }

                    currentIndex += 2

                    //Extra overlap
                    var overlap = sku.substring(currentIndex, currentIndex + 2)
                    var adjustment2 = parseInt(overlap)

                    if (adjustment2 != 0) {
                        var newAdjustment2 = {
                            adjustmentType: 2,
                            parameter1: adjustment2
                        }
                        returnValue.sizeAdjustments.push(newAdjustment2);
                    }

                    currentIndex += 2

                    //velcroMonogram
                    var velcroMonogram = sku.substring(currentIndex, currentIndex + 1)
                    returnValue.velcroMonogram = Boolean(parseInt(velcroMonogram))

                    currentIndex += 1

                    //includeInQuote
                    var includeInQuote = sku.substring(currentIndex, currentIndex + 1)
                    returnValue.includeInQuote = Boolean(parseInt(includeInQuote))

                    currentIndex += 1

                    // monogramLine1
                    var separatorIndex = sku.indexOf('|')
                    var Mono1 = sku.substring(currentIndex, separatorIndex)
                    returnValue.monogramLine1 = Mono1.replaceAll('_', ' ')

                    // monogramLine2
                    var Mono2 = sku.substring(separatorIndex + 1)
                    returnValue.monogramLine2 = Mono2.replaceAll('_', ' ')

                    returnValue.sku = this.configToSku

                    //set quantity to 1
                    returnValue.quantity = 1;

                    return returnValue

                }
            },
            SyncToSkirt: function () {
                //Applies the vest config to the skirt
                var tmpConfig = JSON.parse(JSON.stringify(this.configuredApron))

                //Keep model
                tmpConfig.apronModelID = this.configuredSkirt.apronModelID
                tmpConfig.model = this.configuredSkirt.model
                tmpConfig.quoteApronID = this.configuredSkirt.quoteApronID
                tmpConfig.quoteSetWith = this.configuredSkirt.quoteSetWith

                //Apply
                this.configuredSkirt = JSON.parse(JSON.stringify(tmpConfig))

            },

            goBack: function () {

                if (this.blnIsFav) {
                    this.$router.push({ name: 'ProductSelector', params: { category: 4 } });
                } else {
                    this.$router.push({ name: 'ProductSelector', params: { category: this.configuredApron.model.category } });
                }


            },
            SizeToString: general.SizeToString,


            SaveToFavorites: function () {

                //let sku = this.configuredApron.includeInQuote ? sku = this.$route.params.sku : sku = '';
                //let skuSkirt = this.configuredSkirt.includeInQuote ? skuSkirt = this.$route.params.sku2 : skuSkirt = '';
                let sku = this.$route.params.sku;
                let skuSkirt = this.$route.params.sku2;

                const favorite = {
                    sku: sku,
                    skuSkirt: skuSkirt,
                    name: this.objFavourite.name,
                };

                Bus.$emit('set-modal-data', favorite, SaveFavorite, 'Save to favorite');
                Bus.$emit('open-modal');
            },
        },
        computed: {
            blnIsFav: function () {
                return this.objFavourite.favouriteApronID > 0
            },
            blnFavIsChanged: function () {
                return this.$route.params.sku != this.objFavourite.sku || this.$route.params.sku2 != this.objFavourite.skuSkirt
            },
            cptProducts: function () {
                var categoryProducts = this.lstModels.filter(x => x.category == this.$store.state.chosenCategory);


                var returnValue = []

                //filter out combos
                for (var i = 0; i < categoryProducts.length; i++) {
                    if (returnValue.filter(x => x.apronModelID == categoryProducts[i].apronModelID).length == 0 && returnValue.filter(x => x.apronModelID == categoryProducts[i].setWith).length == 0) {
                        //Add
                        returnValue.push(categoryProducts[i])
                    }
                }

                return returnValue
            },
            AllowAddToQuote: function () {

                if (this.configuredApron.includeInQuote == true) {
                    if (this.configuredApron == null) {
                        return false
                    }

                    if (this.configuredApron.apronModelID < 1) {
                        return false
                    }

                    if (this.configuredApron.fabricColorID < 1) {
                        return false
                    }

                    if (this.configuredApron.ribbonColorID < 1) {
                        return false
                    }

                    if (this.configuredApron.internalMaterial < 1) {
                        return false
                    }

                    if (this.configuredApron.pbEqFront < 1) {
                        return false
                    }

                    if (this.configuredApron.model.category == 2) {
                        //Also check field for back side
                        if (this.configuredApron.pbEqBack < 1) {
                            return false
                        }
                    }


                    if (this.configuredApron.size < 0) {
                        return false
                    }
                }


                if (this.configuredSkirt != null && this.configuredApron.model.setWith > 0 && this.configuredSkirt.includeInQuote) {
                    if (this.configuredSkirt == null) {
                        return false
                    }

                    if (this.configuredSkirt.apronModelID < 1) {
                        return false
                    }

                    if (this.configuredSkirt.fabricColorID < 1) {
                        return false
                    }

                    if (this.configuredSkirt.ribbonColorID < 1) {
                        return false
                    }

                    if (this.configuredSkirt.internalMaterial < 1) {
                        return false
                    }

                    if (this.configuredSkirt.pbEqFront < 1) {
                        return false
                    }

                    if (this.configuredSkirt.model.category == 2) {
                        //Also check field for back side
                        if (this.configuredSkirt.pbEqBack < 1) {
                            return false
                        }
                    }

                    if (this.configuredSkirt.size < 0) {
                        return false
                    }
                }

                return true
            },
            strFormIncomplete: function () {
                if (this.AllowAddToQuote == false) {
                    return '* ' + this.$t('quotation.formIncomplete')
                }

                return ''
            },
            intQuantity: {
                get: function () {

                    return this.configuredApron.quantity
                },
                set: function (newValue) {
                    this.configuredApron.quantity = newValue

                    if (this.configuredSkirt != null) {
                        this.configuredSkirt.quantity = newValue
                    }

                }
            },
            ItemsIdentical: function () {

                if (this.configuredSkirt == null || this.configuredSkirt.includeInQuote == false) {
                    return false
                }

                for (const property in this.configuredApron) {
                    if (property == 'apronID' || property == 'apronModelID' || property == 'department' || property == 'model' || property == 'sku' || property == 'fabricColor' || property == 'ribbonColor' || property == 'sizeAdjustments' || property == 'quoteApronID' || property == 'quoteSetWith') {
                        //These properties may differ
                        continue
                    }

                    if (_.isEqual(this.configuredApron[property], this.configuredSkirt[property]) == false) {
                        return false
                    }
                    //console.log(`${property}: ${this.configuredApron[property]}`);
                }

                return true;
            },
            ...mapState({
                isLoggedIn: state => state.isLoggedIn
            }),
        },
        watch: {
            'configuredApron.includeInQuote': function () {

                if (this.configuredApron.model.setWith > 0) {
                    //Force skirt to refresh SKU
                    this.configuredSkirt.includeInQuote = !this.configuredSkirt.includeInQuote
                    this.configuredSkirt.includeInQuote = !this.configuredSkirt.includeInQuote
                }

            },
            ItemsIdentical: function (newValue) {
                if (newValue) {
                    this.SyncToSkirt();
                }

                //this.blnSyncEnabled = newValue
            },
            blnSyncEnabled: function (newValue) {

                if (newValue) {
                    this.SyncToSkirt();
                }
            },
            configuredApron: {
                deep: true,
                handler: function () {

                    if (this.blnSyncEnabled && this.configuredSkirt != null && this.configuredSkirt.includeInQuote) {
                        //Apply to skirt
                        this.SyncToSkirt();
                    }

                }
            },
            //'$route.params.sku': {
            //    handler(sku) {
            //        if (sku == this.objFavourite.sku) {
            //            this.blnFavIsChanged = false;
            //        } else {
            //            this.blnFavIsChanged = true;
            //        }
            //    },
            //    imediate: true
            //},
            //'$route.params.sku2': {
            //    handler(sku2) {
            //        if (sku2 == this.objFavourite.skuSkirt) {
            //            this.blnFavIsChanged = false;
            //        } else {
            //            this.blnFavIsChanged = true;
            //        }
            //    },
            //    imediate: true
            //},



        },
        created() {
            //window.addEventListener("resize", updateHeight);
            this.GetStoreModel()




        },
        updated() {
            //updateHeight();
        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
